//continue or stop the hit tree traversal
export var HitTestBehavior;
(function (HitTestBehavior) {
    HitTestBehavior[HitTestBehavior["Continue"] = 0] = "Continue";
    HitTestBehavior[HitTestBehavior["Stop"] = 1] = "Stop";
})(HitTestBehavior || (HitTestBehavior = {}));
//# sourceMappingURL=hitTestBehavior.js.map